import { createFileRoute } from "@tanstack/react-router"
import CompletedReviews from "@/routes/-pages/CompletedReviews"

export const Route = createFileRoute("/reviews/completed")({
  component: CompletedReviews,
})
